import * as React from "react";
import { useAuth } from "./utils/auth-context";

const AuthenticatedApp = React.lazy(() =>
  import(/* webpackPrefetch: true*/ "./AuthenticatedApp")
);

const UnauthenticatedApp = React.lazy(() => import("./UnAuthenticatedApp"));

const ReviewerApp = React.lazy(() => import("./ReviewerApp"));

// Paths that are opened from an email link. A stale session can still be in
// localStorage when the link is clicked, and neither AuthenticatedApp nor
// ReviewerApp declares these routes, so they would render a blank page.
const PUBLIC_PATHS = [
  "/reset-password/",
  "/forget-password",
  "/account-active",
  "/incorrect-code",
];

const isPublicPath = (pathname: string) =>
  PUBLIC_PATHS.some(path => pathname.startsWith(path));

export const App = () => {
  const { data: user } = useAuth();

  const showUnauthenticatedApp =
    !user || isPublicPath(window.location.pathname);

  return (
    <React.Suspense fallback={<div />}>
      {showUnauthenticatedApp ? (
        <UnauthenticatedApp />
      ) : user?.role === "reviewer" && user?.permission_id === null ? (
        <ReviewerApp />
      ) : (
        <AuthenticatedApp />
      )}
    </React.Suspense>
  );
};
